export default __webpack_public_path__ + "static/wheel_chair_w.59f567fbaf0359abebb72e87c02abd16.svg";